import { render, staticRenderFns } from "./issues_list_app.vue?vue&type=template&id=8585e3da"
import script from "./issues_list_app.vue?vue&type=script&lang=js"
export * from "./issues_list_app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports